// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Fa0M","footer":"Form_footer__Sc9Cc"};